"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatedPushNotification = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../util/runtypeImplementing");
var data_1 = require("./data");
var CommentReplyData_1 = require("./data/CommentReplyData");
var Data_1 = require("./data/Data");
var OrderAdjustmentData_1 = require("./data/OrderAdjustmentData");
var OrderInfoFieldUpdatedData_1 = require("./data/OrderInfoFieldUpdatedData");
var OrderRefundLineItemsData_1 = require("./data/OrderRefundLineItemsData");
var OrderStatusData_1 = require("./data/OrderStatusData");
var PaymentFailureData_1 = require("./data/PaymentFailureData");
var RecurringSubscriptionData_1 = require("./data/RecurringSubscriptionData");
var RsvpReminderData_1 = require("./data/RsvpReminderData");
var SessionCancelledData_1 = require("./data/SessionCancelledData");
var SineSignInOutData_1 = require("./data/SineSignInOutData");
exports.CreatedPushNotification = (0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("created"),
}).And((0, runtypes_1.Partial)({
    notification: (0, runtypes_1.Partial)({
        body: runtypes_1.String,
        title: runtypes_1.String,
        webIcon: runtypes_1.String,
        tag: runtypes_1.String,
    }),
    data: (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Union)(Data_1.Data, data_1.DeepLinkData, CommentReplyData_1.CommentReplyData, RsvpReminderData_1.RsvpReminderData, OrderStatusData_1.OrderStatusData, OrderAdjustmentData_1.OrderAdjustmentData, OrderInfoFieldUpdatedData_1.OrderInfoFieldUpdatedData, OrderRefundLineItemsData_1.OrderRefundLineItemsData, PaymentFailureData_1.PaymentFailureData, data_1.ProfileUpdatedData, RecurringSubscriptionData_1.RecurringSubscriptionData, SessionCancelledData_1.SessionCancelledData, SineSignInOutData_1.SineSignInOutData, data_1.SiteUpdatedData)),
}));
//# sourceMappingURL=CreatedPushNotification.js.map